"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResultsFilterBar = void 0;
var react_1 = __importDefault(require("react"));
var Tabs_1 = require("@components/Tabs");
var react_i18next_1 = require("react-i18next");
function ResultsFilterBar(_a) {
    var statusList = _a.statusList, activeStatus = _a.activeStatus, onStatusChange = _a.onStatusChange, decisionList = _a.decisionList, activeDecision = _a.activeDecision, onDecisionChange = _a.onDecisionChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Tabs_1.Tabs, { tabs: __spreadArray([{ label: t('DASHBOARD.ITEM_LOG.TABLE.TABS.ALL'), id: 'all', query: '' }], __read(statusList), false), activeTab: !activeStatus ? 'all' : activeStatus.id, onChange: function (tab) {
                if (tab.id === 'all') {
                    onStatusChange();
                }
                else {
                    onStatusChange(tab);
                }
            } }),
        ((activeStatus && ['APPROVE', 'REFUSE', 'NO DECISION'].includes(activeStatus === null || activeStatus === void 0 ? void 0 : activeStatus.id)) || !activeStatus) && (react_1.default.createElement(Tabs_1.TabsWithChip, { tabs: __spreadArray([{ label: t('DASHBOARD.ITEM_LOG.TABLE.TABS.ALL'), id: 'all', prefix: '' }], __read(decisionList), false), activeTab: !activeDecision ? 'all' : activeDecision, onChange: function (tab) {
                if (tab.id === 'all') {
                    onDecisionChange();
                }
                else {
                    onDecisionChange(tab.id);
                }
            } }))));
}
exports.ResultsFilterBar = ResultsFilterBar;
